type Image = {
  source_url: string
  name: string
  width: string
  height: string
}
type Hit = {
  post_title: string
  images?: {
    medium?: Image
    full?: Image
  }
}

export function extractImageFromHit(hit: Hit, assetPath: string) {
  let image: Image = {
    source_url: `${assetPath}/images/empty-asset.webp`,
    name: 'empty-asset',
    width: '217',
    height: '122'
  }
  let alt = hit.post_title
  if (hit.images) {
    const validImages = hit.images ? Object.keys(hit.images) : []

    if (validImages.includes('medium')) {
      image = hit.images.medium!
    } else if (validImages.includes('full')) {
      image = hit.images.full!
    }
  }

  return {
    image,
    alt
  }
}

// Remove all absolute urls
const apiUrl = `https://backend.maxroll.net`
export function parseUrl(url: string) {
  if (url.startsWith('http') && !url.includes('maxroll')) {
    return url
  }

  const uri = url
    .replace(apiUrl, '')
    .replace('https://staging.maxroll.net', '')
    .replace('https://maxroll.gg', '')
  return 'https://maxroll.gg' + uri
}

export function isStringInObject(searchQuery: string, obj: any) {
  const query = searchQuery.toLowerCase()
  for (const key of Object.keys(obj)) {
    const value = obj[key]
    if (
      value == query ||
      (typeof value === 'string' && value.toLowerCase().includes(query))
    ) {
      return true
    }
  }

  return false
}
